export default {
  name: 'iab-blacklist',
  class: 'h-6 w-6',
  box: 24,
  svg: `<path d="M10 18H14.5V20H10V18Z" fill="fillcolor"/>
  <path d="M5.38 19.5L3.445 21.435L4.5025 22.5L7.5025 19.5L4.5025 16.5L3.4375 17.5575L5.38 19.5Z" fill="fillcolor"/>
  <path d="M10 11H21V13H10V11Z" fill="fillcolor"/>
  <path d="M5.38 12L3.445 13.935L4.5025 15L7.5025 12L4.5025 9L3.4375 10.0575L5.38 12Z" fill="fillcolor"/>
  <path d="M10 4H21V6H10V4Z" fill="fillcolor"/>
  <path d="M5.38 4.5L3.445 6.435L4.5025 7.5L7.5025 4.5L4.5025 1.5L3.4375 2.5575L5.38 4.5Z" fill="fillcolor"/>
  <path d="M21.6875 16L19.5 18.1875L17.3125 16L16 17.3125L18.1875 19.5L16 21.6875L17.3125 23L19.5 20.8125L21.6875 23L23 21.6875L20.8125 19.5L23 17.3125L21.6875 16Z" fill="fillcolor"/>`,
};
